import { CoreWarning, throwGlobal } from '@goodt-wcore/errors';

export const useSharedApi = (vm) => ({
    toast: () => {
        throwGlobal(new CoreWarning('"$shared.toast" is not implemented'));
    },
    clipboard: (data) => {
        return window.navigator.clipboard.writeText(JSON.stringify(data, null, 2));
    },
    confirm: ({ text }) => {
        const promise = Object.assign(
            new Promise((resolve) => {
                const isConfirmed = window.confirm(text);
                resolve(isConfirmed);
            }),
            {
                yes: (fn) => {
                    promise.then((isConfirmed) => {
                        if (isConfirmed === true) {
                            fn();
                        }
                        return promise;
                    });
                    return promise;
                },
                no: (fn) => {
                    promise.then((isConfirmed) => {
                        if (isConfirmed === false) {
                            fn();
                        }
                        return promise;
                    });
                    return promise;
                }
            }
        );
        return promise;
    },
    error: (error, { context, scope = error.scope, message } = {}) => {
        vm.$errorService.handleError({ error, context, scope, message });
    },
    showComponent: () => {
        throwGlobal(new CoreWarning('"$shared.showComponent" is not implemented'));
    },
    hideComponent: () => {
        throwGlobal(new CoreWarning('"$shared.hideComponent" is not implemented'));
    },
    toggleRouteView: () => {
        throwGlobal(new CoreWarning('"$shared.toggleRouteView" is not implemented'));
    },
    keyboard: () => {
        throwGlobal(new CoreWarning('"$shared.keyboard" is not implemented'));
    }
});